import styled, { css } from 'styled-components';

interface ItemProps {
  readonly aWidth?: string;
  readonly clickable?: boolean;
  readonly icon?: boolean;
  readonly inputStyle?: string;
  readonly inputStatus?: string;
  readonly iconExtraPadding?: boolean;
  readonly insetShadow?: string;
  readonly responsive?: string;
  readonly fSize?: number;
  readonly cPlaceholder?: string;
  readonly iPadding?: string;
  readonly bordeRadius?: string;
  readonly backgroundColor?: string;
  readonly color?: string;
}

function verifyDynamicWidth(props: any): any {
  const aWidth = `width: ${props.aWidth};`;
  return css`
    ${aWidth}
  `;
}

export const InputContainer = styled.div<ItemProps>`
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
  height: 45px;
  position: relative;
  align-items: center;
  display: inline-flex;
  transition: 0.3s ease;
  box-sizing: border-box;
  border-radius: ${props => props.bordeRadius};
  padding: ${props => (props.icon ? '5px 30px 5px 15px' : '5px 15px 5px 15px')};
  ${props => verifyDynamicWidth(props)}
  ${props => {
    let background: any;
    if (props.backgroundColor) {
      background = `background-color: ${props.backgroundColor}`
    } else {
      background = `background-color: ${props.inputStyle === 'dark' ? '#F7F7F7' : props.inputStatus === 'disabled' ? '#EBEDF2' : '#ffffff'}`
    }

    return css`{
      ${background}
    }`
  }}

  border: ${props =>
    props.inputStyle === 'error'
      ? '1px solid var(--PrimaryRed)'
      : props.inputStyle === 'success'
        ? '1px solid #51E363;'
        : '1px solid var(--LightGray)'};
  pointer-events: ${props => (props.inputStatus === 'disabled' ? 'none' : 'all')};
  cursor: ${props => (props.inputStatus === 'disabled' ? 'not-allowed' : 'default')};

  &:active {
    width: 100%;
  }

  &:focus {
    width: 100%;
  }

  &:hover {
    width: 100%;
  }

  &:enabled {
    width: 100%;
  }
  & div {
    position: absolute;
    right: 0;
  }
`;

export const InputElement = styled.input<ItemProps>`
  width: 100%;
  height: 100%;
  border: none;
  transition: 0.3s ease;
  display: inline-block;
  background-color: transparent;
  font-size: ${props => props.fSize}px;
  min-width: ${props => props.maxLength}px;

  ${props => {
    let color: string;
    if (props.inputStyle === 'error') {
      color = 'color: #CC0000';
    } else if (props.inputStyle === 'dark') {
      color = 'color: #5D6C76';
    } else if (props.color) {
      color = `color: ${props.color}`;
    } else {
      color = 'color: #000';
    }

    return css`{
      ${color}
    }`
  }}

  &:active {
    border: none;
    outline: none;
  }

  &:focus {
    border: none;
    outline: none;
  }

  &::placeholder {
    color: ${props => props.cPlaceholder};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    ${props => `box-shadow: 0 0 0px 1000px ${props.insetShadow} inset !important;`}
  }

  ${props => {
    if (props.responsive) {
      return css`
        @media (max-width: ${props.responsive}) {
          &::placeholder {
            color: transparent;
          }
        }
      `;
    } else {
      return '';
    }
  }}
`;

export const InputIcon = styled.div<ItemProps>`
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  padding-top: ${props => (props.iconExtraPadding ? '10px' : '0')};
  padding-right: ${props => (props.iPadding ? props.iPadding : '5px')};
`;

export const TextIcon = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #017CFF;
`;
